import { useEffect, useState } from "react";
import { communeAt } from "../model/route";
import { fmtDuration, stationCost } from "../model/run";
import { useApp } from "../state/store";

/** Une gare sélectionnée : nom, PK, coût pour les autres voyageurs, suppression. */
export function PanneauGare() {
  const idx = useApp((s) => s.selected)!;
  const route = useApp((s) => s.route)!;
  const result = useApp((s) => s.result)!;
  const scenario = useApp((s) => s.scenario);
  const rename = useApp((s) => s.renameStop);
  const remove = useApp((s) => s.removeStop);
  const select = useApp((s) => s.select);
  const stationName = useApp((s) => s.stationName);
  const isTerminus = useApp((s) => s.isTerminus(idx));
  const dragging = useApp((s) => s.dragging);

  const name = stationName(idx);
  const [draft, setDraft] = useState(name);
  useEffect(() => setDraft(name), [name, idx]);

  const k = result.stops.indexOf(idx);
  const cost = k > 0 && k < result.stops.length - 1 ? stationCost(route, scenario.stops, idx, scenario.settings) : null;
  const ref = route.reference_stations.find((s) => s.idx === idx);
  const pk = (idx * route.step_m) / 1000;
  const vmax = route.vmax_kmh[idx];

  return (
    <section className="gare" aria-label="Gare sélectionnée">
      <div className="gare-nom">
        <input
          type="text"
          value={draft}
          maxLength={60}
          aria-label="Nom de la gare"
          onChange={(e) => setDraft(e.target.value)}
          onBlur={() => draft !== name && rename(idx, draft)}
          onKeyDown={(e) => e.key === "Enter" && (e.target as HTMLInputElement).blur()}
        />
        <button type="button" className="fermer" onClick={() => select(null)} aria-label="Fermer">
          ×
        </button>
      </div>
      <p className="gare-meta">
        PK {pk.toFixed(1)} · {communeAt(route, idx)}
        {ref ? ` · gare du dossier${ref.detail ? ` (${ref.detail})` : ""}` : " · gare ajoutée"}
        {scenario.settings.useVmax && ` · vitesse ici ${vmax} km/h`}
      </p>
      {cost !== null && (
        <p className="gare-cout">
          Cette gare coûte <strong>+{Math.round(cost)} s</strong> à tous les voyageurs qui la traversent.
          {vmax < 90 && " Le train y est déjà lent : c'est là qu'une gare coûte le moins."}
        </p>
      )}
      {k >= 0 && (
        <p className="gare-meta">
          {k === 0 ? "Départ" : `Arrivée à +${fmtDuration(result.arrivals[k])}`} depuis {route.termini[0]}
          {dragging === idx && " · glissez le long du tracé"}
        </p>
      )}
      <div className="gare-actions">
        {!isTerminus && (
          <button type="button" className="danger" onClick={() => remove(idx)}>
            Supprimer cette gare
          </button>
        )}
        {isTerminus && <span className="gare-meta">Terminus : ne se supprime pas.</span>}
      </div>
    </section>
  );
}
